import { FC, PropsWithChildren } from 'react';
import { StyleProvider as AntSSRStyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';
import { ThemeProvider as StyledComponentProvider } from 'styled-components';

import { antTheme } from '@/shared/constants/ant-theme';

const theme = {
  main: 'mediumseagreen',
};

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyledComponentProvider theme={theme}>
      <AntSSRStyleProvider hashPriority={'high'} ssrInline={true}>
        <ConfigProvider theme={antTheme}>{children}</ConfigProvider>
      </AntSSRStyleProvider>
    </StyledComponentProvider>
  );
};
